import memberDetailsData from '../data/memberDetails.json';

export const getMemberDetail = (memberId) => {
  console.log(`Getting member details for id: ${memberId}`);
  return new Promise((resolve) => {
    const member = memberDetailsData.filter((p) => {
      return p.member_id === memberId;
    })[0];
    
    resolve(member);
  });
};

export const getMemberCard = (memberId) => {
  console.log(`Getting member card for id: ${memberId}`);
  return new Promise((resolve) => {
    const member = memberDetailsData.filter((p) => {
      return p.member_id === memberId;
    })[0];
    
    resolve(member);
  });
};
